import { jsx as _jsx } from "react/jsx-runtime";
import { Environment } from '@as-react/common-utils';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { bindActionCreators } from 'redux';
import { makeGetProductDefaults } from '../../../redux/product/selectors/ProductSelector';
import { connect } from 'react-redux';
import { PureComponent } from 'react';
import { AemConfigurationContext } from '@as-react/common-components';
import ServerSideInclude from '../server-side-include/ServerSideInclude';
class EsiData extends PureComponent {
    constructor(props) {
        super(props);
        this.buildPricesUrl = (mainWebShop, fictiveWebShop, lang) => {
            const { productDefaults } = this.props;
            return (`${Environment.isDevelopment() ? 'http://localhost:8081/hypernova/esi/' : '/api/hypernova/esi/'}` +
                `product-detail/${mainWebShop}/${fictiveWebShop}` +
                `/${productDefaults.productId}` +
                `/${lang}`);
        };
    }
    render() {
        const { keyName, setEsiData } = this.props;
        return (_jsx(AemConfigurationContext.Consumer, { children: configuration => {
                const { mainWebShop, fictiveWebShop, lang } = configuration;
                const url = this.buildPricesUrl(mainWebShop, fictiveWebShop, lang);
                return _jsx(ServerSideInclude, { dataKey: keyName, throwAction: setEsiData, url: url });
            } }));
    }
}
const makeMapStateToProps = () => {
    const getProductDefaults = makeGetProductDefaults();
    const mapStateToProps = (state) => ({
        productDefaults: getProductDefaults(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    setEsiData: productActions.createSetEsiDataAction,
}, dispatch);
export default connect(makeMapStateToProps, mapDispatchToProps)(EsiData);
